import { IClientsOverviewResponse, ClientsOverviewViewModel } from "./types";
import { formatCurrencyBRL } from "src/lib/utils/numberFormat";

export { formatCurrencyBRL } from "src/lib/utils/numberFormat";

export const mapPerfilToProfile = (
    perfil: string
): ClientsOverviewViewModel["topClients"][number]["clientInvestProfile"] => {
    const normalized = perfil?.toUpperCase();

    switch (normalized) {
        case "CONSERVADOR":
            return "conservative";
        case "MODERADO":
        case "BALANCEADO":
            return "balanced";
        case "SOFISTICADO":
        default:
            return "sophisticated";
    }
};

export const transformClientsOverviewResponse = (
    response: IClientsOverviewResponse
): ClientsOverviewViewModel => {
    return {
        totalAmountFormatted: formatCurrencyBRL(response.total_amount),
        numberOfClients: response.number_of_clients,
        topClients: response.top_clients.map((item) => ({
            clientName: item.cliente.name,
            clientInvestProfile: mapPerfilToProfile(item.cliente.perfil),
            clientAmount: formatCurrencyBRL(item.net_worth),
        })),
    };
};


